import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LocalStorageService } from 'ngx-webstorage';
import { AuthService } from 'src/app/auth/auth.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {

  role: string = "";
  userLoginId!: string;
  ballance = 0;

  constructor(
    private router: Router,
    private localStorage: LocalStorageService,
    private authService: AuthService
  ) {

  }

  ngOnInit(): void {
    this.userLoginId = this.localStorage.retrieve("userInfo").userId;
    this.role = this.localStorage.retrieve("userInfo").role;
    console.log(this.role)
    if (this.role == "Admin") {
      this.router.navigate(["./master/cards/paymentrequests"]);
    }
    else {
      this.getUserLoginBalance()
    }
  }

  getUserLoginBalance() {
    this.authService.getById(this.userLoginId).subscribe(data => {
      this.ballance = data["balance"];
    })
  }

}
